<template>
  <el-card
class="card-container"
shadow="never">
    <el-row
slot="header"
type="flex"
justify="space-between"
align="middle">
      <h1 class="card-container__title">Nhóm hiển thị ({{ data.length }})</h1>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="handleCreate"
      >
        Thêm mới
      </el-button>
    </el-row>
    <el-table
header-row-class-name="table-header"
:data="data"
size="small">
      <el-table-column
        v-for="(c, index) in columns"
        :key="index"
        :prop="c.key"
        :label="c.label"
        :align="c.align"
        :width="c.width"
        :min-width="c.min_width"
      >
        <template slot-scope="scope">
          <span v-if="c.key === 'fields'">
            <el-tag
              v-for="field in showListFields(scope.row[c.key] || [])"
              :key="field.key"
              class="mr-xs mb-xs"
              size="mini"
            >
              {{ field.name }}
            </el-tag>
            ({{ (scope.row[c.key] || []).length }})
          </span>
          <span v-else>
            {{ scope.row[c.key] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="Thao tác"
        width="100"
        fixed="right"
        align="center"
      >
        <template slot-scope="scope">
          <Buttons
            :item="scope.row"
            :buttons="['edit', 'delete']"
            @edit="(v) => handleUpdate(v)"
            @delete="(v) => handleDelete(v)"
          />
        </template>
      </el-table-column>
    </el-table>
    <GroupFormPopup
      v-if="formVisible"
      :visible="formVisible"
      :item="selectedItem"
      :groups="data"
      :fields="fields"
      @close="formVisible = false"
      @save="handleSave"
    />
  </el-card>
</template>

<script>
import GroupFormPopup from "../../popups/GroupForm.vue";
import Buttons from "@/components/items/Buttons.vue";
import { notification } from "@/utils/common";

export default {
  name: "ConfigObjectGroups",
  components: {
    GroupFormPopup,
    Buttons,
  },
  props: {
    object: Object,
  },
  data() {
    return {
      selectedItem: null,
      formVisible: false,
    };
  },
  computed: {
    data() {
      return (this.object?.extra?.groups || []).sort(
        (a, b) => a.order - b.order
      );
    },
    fields() {
      const data = this.object?.extra?.fields || [];
      return data;
    },
    columns() {
      return [
        {
          label: "STT",
          key: "order",
          width: 50,
        },
        {
          label: "Mã nhóm",
          key: "key",
          width: 150,
        },
        {
          label: "Tên nhóm",
          key: "name",
          width: 200,
        },
        {
          label: "Trường dữ liệu",
          key: "fields",
        },
      ];
    },
  },
  methods: {
    handleCreate() {
      this.selectedItem = null;
      this.formVisible = true;
    },
    handleUpdate(item) {
      this.selectedItem = item;
      this.formVisible = true;
    },
    handleDelete(item) {
      this.$confirm(`Bạn có chắc chắn muốn xoá không?`, "Xác nhận", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      }).then(() => {
        const groups = this.data.filter((g) => g.key !== item.key);
        this.handleSave({
          payload: { groups },
          success: () => {
            notification(this, "success", "delete", `nhóm hiển thị`);
          },
          error: () => {
            notification(this, "error", "delete", "nhóm hiển thị");
          },
        });
      });
    },
    handleSave(data = { payload: {}, success: () => {}, error: () => {} }) {
      this.$emit("save", {
        payload: data.payload,
        success: data.success,
        error: data.error,
      });
    },
    showListFields(keys = []) {
      return this.fields.filter((f) => keys.includes(f.key))
    },
  },
};
</script>

<style lang="scss" scoped></style>
